import "./demoClasses.scss";

import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "../../components/Pagination";
import Filter from "../../components/elements/Filter";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import TableList from "../../components/elements/TableList";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import { setDemoClass } from "../../store/slices/generics.slice";
import classIcon from "../../assets/images/icons/icon_democlasses_header.svg";
import { getDemoClasses, getLingoPlans, resetCycle } from "../../store/middleware";

function DemoClasses() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { demoClassesObj } = useSelector((state) => state.genericReducer);

  const [filter, setFilter] = useState({
    pageNumber: 1,
    pageSize: 10,
    student: "",
    lingoLanguageId: "",
    startAt: "",
    endAt: "",
    status: "",
    email: "",
    orderByDesc: "createdAt",
  });

  const loadInfos = async () => {
    await dispatch(getDemoClasses(filter));
    await dispatch(getLingoPlans(null));
  };

  const pagination = (page) => {
    filter["pageNumber"] = Number(page);
    setFilter(filter);
    applyFilters(null, false);
  };

  const inputChange = (e, name) => {
    const { value } = e.target;
    setFilter((state) => ({ ...state, [name]: value }));
  };

  const applyFilters = (e, resetPage) => {
    if (e) e.preventDefault();

    if (resetPage) {
      filter["pageNumber"] = Number(1);
      setFilter(filter);
    }
    dispatch(getDemoClasses(filter));
  };

  const resetFilter = async (e) => {
    e.preventDefault();
    await setFilter({
      pageNumber: 1,
      pageSize: 10,
      student: "",
      lingoLanguageId: "",
      startAt: "",
      endAt: "",
      status: "",
      email: "",
      orderByDesc: "createdAt",
    });

    await dispatch(
      getDemoClasses({
        pageNumber: 1,
        pageSize: 10,
        student: "",
        lingoLanguageId: "",
        startAt: "",
        endAt: "",
        status: "",
        email: "",
        orderByDesc: "createdAt",
      }),
    );
  };

  const handleAddNewDemoClass = () => {
    dispatch(setDemoClass(null));
    navigate("/demo-class/new");
  };

  const handleResetCycle = async (e) => {
    e.preventDefault();
    await dispatch(resetCycle("demoClass")).then((res) => alert(res.data.msg));
    loadInfos();
  };

  const listedDemoClass =
    demoClassesObj &&
    demoClassesObj?.demoClasses &&
    demoClassesObj?.demoClasses
      ?.filter((item) => item?.demoClassSchedules.length > 0)
      .map((item) => {
        const lingo = item?.demoClassSchedules?.map((itemFlag) => itemFlag.lingoLanguage?.flag);

        const lang = localStorage.getItem("i18nextLng");
        let newLang = lang.split("-");

        return {
          id: item?.id,
          classLingo: lingo,
          student: decryptIfEncrypted(item?.name),
          date: moment(
            item.demoClassSchedules[item?.demoClassSchedules.length - 1].originalScheduledDateTimeUTC,
          ).format(newLang[0] === "en" ? "MM/DD/YYYY hh:mm a" : "DD/MM/YYYY hh:mm a"),
          status: item?.demoClassSchedules[item?.demoClassSchedules.length - 1]?.status,
        };
      });

  const listItems = [
    { label: "Student", name: "student" },
    { label: "Class Lingo", name: "classLingo" },
    { label: "First Appointment", name: "date" },
    { label: "Status", name: "status" },
    { label: "", name: "button" },
  ];

  const statusOptions = ["Review", "Pending", "NoShow", "Canceled", "Done", "CancelledOutOfLimit", "Confirmed"]?.map(
    (option, i) => ({
      id: i,
      name: option,
    }),
  );

  const filters = [
    { name: "student", value: filter.student, label: "STUDENT", placeholder: "STUDENT_NAME", type: "text" },
    { name: "email", value: filter.email, label: "EMAIL", placeholder: "STUDENT_EMAIL", type: "text" },
    {
      type: "lingoLanguages",
      placeholder: "Select",
      name: "lingoLanguageId",
      label: "Native Language",
      value: filter.lingoLanguageId,
    },
    {
      type: "date",
      name: "startAt",
      placeholder: "Select",
      label: "PERIOD_START",
      value: filter.startAt,
    },
    {
      type: "date",
      name: "endAt",
      label: "PERIOD_END",
      value: filter.endAt,
      placeholder: "Select",
    },
    {
      name: "status",
      type: "status",
      label: "Status",
      value: filter.status,
      placeholder: "Select",
      options: statusOptions,
    },
  ];

  useEffect(() => {
    loadInfos();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header
          t={t}
          icon={classIcon}
          title={t("DEMO_CLASS")}
          rightButton={
            <button className="buttonRight" onClick={() => handleAddNewDemoClass()}>
              <i className="fa fa-plus" aria-hidden="true" /> {`${t("ADD_NEW")} ${t("DEMO_CLASS")}`}
            </button>
          }
        />

        <div className="content">
          <Filter
            resetCycle
            filters={filters}
            clear={resetFilter}
            submit={applyFilters}
            inputChange={inputChange}
            resetCycleClick={handleResetCycle}
          />
          <TableList component="demo-class" listItems={listItems} listedItems={listedDemoClass} action="demoClass" />

          <Pagination
            totalPages={demoClassesObj?.totalPages}
            totalTaken={demoClassesObj?.totalTaken}
            pageCurrent={demoClassesObj?.pageNumber}
            totalResults={demoClassesObj?.totalFound}
            onClick={(page, type) => pagination(page, type)}
          />
        </div>
      </section>
    </div>
  );
}
export default DemoClasses;
